export default __webpack_public_path__ + "static/media/slide_option_two.78519669.jpg";